import { render } from "./VMPerformanceOptions.vue?vue&type=template&id=fb5b986c&scoped=true"
import script from "./VMPerformanceOptions.vue?vue&type=script&lang=js"
export * from "./VMPerformanceOptions.vue?vue&type=script&lang=js"

import "./VMPerformanceOptions.vue?vue&type=style&index=0&id=fb5b986c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb5b986c"]])

export default __exports__